module.exports = __webpack_public_path__ + "static/media/biologyBg.6293cf71.svg";